import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="lg">
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © 2024 VisaForge. All rights reserved.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link 
              href="#" 
              color="text.secondary" 
              underline="hover"
              variant="body2"
            >
              Privacy Policy
            </Link>
            <Link 
              href="#" 
              color="text.secondary" 
              underline="hover"
              variant="body2"
            >
              Terms of Service
            </Link>
            <Link 
              href="#" 
              color="text.secondary" 
              underline="hover"
              variant="body2"
            >
              Contact
            </Link>
          </Box>
        </Box>
        
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            This platform provides immigration guidance for informational purposes only. 
            Always consult with qualified immigration professionals for legal advice.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;